import { CIcon } from '~/icons/types'
export const ciUserPlus: CIcon = {
  name: 'user-plus',
  type: 'solid',
  width: 512,
  height: 459.1,
  paths: [
    {
      d:
        'M353.7 387.8h-53c-20.5 0-37.3-16.8-37.3-37.3v-12.3c0-20.5 16.8-37.3 37.3-37.3h53v-18.5C333.5 267.1 308.4 258 281 258h-15c-19.9 9.1-42 14.3-65.3 14.3s-45.3-5.2-65.3-14.3h-15C54 258.1 0 312.1 0 378.6v37.3c0 23.7 19.3 43 43 43h315.5c-3-5.4-4.7-11.6-4.7-18.2v-52.9zM200.7 0C50 2.6 50 226.9 200.8 229.4 351.5 226.9 351.5 2.6 200.7 0z',
      fill: 'currentColor'
    },
    {
      d:
        'M493.5 319.7h-71.8v-71.8c0-10.1-8.3-18.5-18.5-18.5H391c-10.1 0-18.5 8.3-18.5 18.5v71.7h-71.8c-10.1 0-18.5 8.3-18.5 18.5v12.3c0 10.1 8.3 18.5 18.5 18.5h71.8v71.8c0 5.2 2.2 9.9 5.7 13.4 3.3 3.1 7.8 5.1 12.7 5.1h12.3c10.1 0 18.5-8.3 18.5-18.5v-71.8h71.8c10.1 0 18.5-8.3 18.5-18.5v-12.3c0-10.1-8.3-18.4-18.5-18.4z',
      fill: 'currentColor'
    }
  ]
}
